// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92539c94","453":"3445c983","455":"26d0512e","977":"6f87be8b"}[chunkId] + ".chunk.js";
};